import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-profile-edit',
  template: `
  <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Perfiles y roles</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto" style="min-width: 360px !important;">        
        <div class="list-group rounded-4 rounded-md-5">
          <div class="list-group-item py-4">
            <app-form-profile 
              (profileData)="updateProfile($event)" 
              [profile]="profile" 
              [loading]="loading"
            ></app-form-profile>
          </div>
        </div>
      </div>
      <div class="ms-2">
        <div class="list-group rounded-4 rounded-md-5">
          <div class="list-group-item table-responsive py-4">
            <ul ngbNav #nav="ngbNav" [(activeId)]="active" [destroyOnHide]="false" class="nav-tabs">
              <li [ngbNavItem]="1" [destroyOnHide]="true" style="">
                <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Registro público</button>
                <ng-template ngbNavContent>
                  <h5 class="mt-3">Registro público</h5>
                  <p>Configura el registro público con los siguientes campos.</p>
                  <app-form-public-record [publicRecord]="public_record" (publicRecordData)="createPublicRecord($event)"></app-form-public-record>
                </ng-template>
              </li>
              <li [ngbNavItem]="2" [destroyOnHide]="true" style="">
                <button ngbNavLink class="btn btn-link bg-transparent rounded-0">Registro público</button>
                <ng-template ngbNavContent>
                  <h5 class="mt-3">Representante legal</h5>
                  <app-form-public-record [publicRecord]="legal_rep" [isLegal]="true" [related]="public_record.id" (publicRecordData)="createLegalRep($event)"></app-form-public-record>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav"></div>




            <!-- ul class="nav nav-tabs" #tabs>
              <li class="nav-item">
                <a #menu1 class="nav-link active" data-toggle="tab" href="#registro" (click)="tab($event)" >Registro público</a>
              </li>
              <li class="nav-item" *ngIf="public_record !== null">
                <a class="nav-link" data-toggle="tab" href="#representante" (click)="tab($event)"></a>
              </li>
            </ul>  
            <div #tabContent class="tab-content">                
              <div id="registro" class="tab-pane registro active ps-3 pe-3" *ngIf="public_record">
                
              </div>
              <div id="representante" class="tab-pane representante ps-3 pe-3" *ngIf="public_record">
                
              </div>
            </div -->
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class ProfileEditComponent implements OnInit {
  @ViewChild('tabs') tabs!: ElementRef | undefined;
  @ViewChild('tabContent') tabContent!: ElementRef | undefined;
  
  profile: any = null;
  public_record: any = null;
  legal_rep: any = null;
  loading: boolean = false;

  active = 1;

  currentView: string = 'perfiles';

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    public authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.set('@profiles', 'Perfiles');
    this.loading = true;
    this.activateRoute.params.subscribe(params => {
      this.store.getProfile(params['id']).subscribe({
        next: (res: any) => {
          this.loading = false;
          this.profile = res;
          if (this.profile.public_record_id) {
            this.store.getPublicRecord(this.profile.public_record_id).subscribe((data:any) => {
              this.public_record = data;
            });
          }
          this.breadcrumbService.set('@profileEdit', this.profile.name);
        },
        error: (err: any) => {
          console.log(err);
          this.loading = false;
          this.toastr.error('Ocurrió un error al obtener el perfil.', 'Error');
        }
      });
    });
  }

  tab(e: any) {
    e.preventDefault();
    //
    this.tabs?.nativeElement.querySelectorAll('.nav-link').forEach((tab: any) => {
      tab.classList.remove('active');
    });
    this.tabContent?.nativeElement.querySelectorAll('.tab-pane').forEach((tabPane: any) => {
      tabPane.classList.remove('active');
    });
    e.target.classList.add('active');
    this.tabContent?.nativeElement.querySelector(`.${e.target.href.split('#')[1]}`)?.classList.add('active');
  }

  updateProfile(event: any) {
    console.log("update ", event);

    this.store.updateProfile(this.profile.id, event).subscribe({
      next: (res: any) => {
        this.toastr.success('La perfil se actualizó correctamente.', 'Actualizado');
        this.router.navigate(['/perfiles']);
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error('Ocurrió un error al actualizar el perfil.', 'Error');
      }
    });
  }

  createLegalRep(event: any) {
    const payload: any = event;
    payload.profile_id = this.profile.id;

    if (event.id) {
      this.store.updatePublicRecord(event.id, event).subscribe({
        next: (res: any) => {
          console.log('updatePublicRecord res', res);
          this.toastr.success('El registro público se actualizó correctamente.', 'Actualizado');
          // this.store.updateProfile(this.profile.id, { public_record_id: res.id }).subscribe((data: any) => {
          // this.router.navigate(['/perfiles']);
          // });
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Ocurrió un error al actualizar el registro público.', 'Error');
        }
      });
    } else {
      this.store.createPublicRecord(event).subscribe({
        next: (res: any) => {
          console.log('createPublicRecord res', res);
          this.toastr.success('El registro público se creó correctamente.', 'Creado');
          // this.store.updateProfile(this.profile.id, { public_record_id: res.id }).subscribe((data: any) => {
            // this.router.navigate(['/perfiles']);
          // });
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Ocurrió un error al crear el registro público.', 'Error');
        }
      });
    }
  }

  createPublicRecord(event: any) {
    console.log("create ", event);

    const payload: any = event;
    payload.profile_id = this.profile.id;

    if (event.id) {
      this.store.updatePublicRecord(event.id, event).subscribe({
        next: (res: any) => {
          console.log('updatePublicRecord res', res);
          this.toastr.success('El registro público se actualizó correctamente.', 'Actualizado');
          this.store.updateProfile(this.profile.id, { public_record_id: res.id }).subscribe((data: any) => {
          // this.router.navigate(['/perfiles']);
          });
        },
        error: (err: any) => {
          console.log(err);
          this.toastr.error('Ocurrió un error al actualizar el registro público.', 'Error');
        }
      });
    } else {
    this.store.createPublicRecord(event).subscribe({
      next: (res: any) => {
        console.log('createPublicRecord res', res);
        this.toastr.success('El registro público se creó correctamente.', 'Creado');
        this.store.updateProfile(this.profile.id, { public_record_id: res.id }).subscribe((data: any) => {
          // this.router.navigate(['/perfiles']);
        });
      },
      error: (err: any) => {
        console.log(err);
        this.toastr.error('Ocurrió un error al crear el registro público.', 'Error');
      }
    });
  }
  }
}
